import {Moment} from 'moment-timezone'

export type NumberRange = [number, number]
export type MomentRange = [Moment, Moment]

export const calculateRangeWithinBoundary = (
  inputRange: [number, number],
  boundary: [number, number]
): [number, number] => {
  const [startRange, endRange] = inputRange
  const delta = endRange - startRange
  const [min, max] = boundary

  if (delta > max - min) {
    return boundary
  }
  if (startRange < min) {
    return [min, min + delta]
  }
  if (endRange > max) {
    return [max - delta, max]
  }
  return inputRange
}

export const calculateDatetimeRangeWithinBoundary = (
  inputRange: MomentRange,
  boundary: MomentRange
): MomentRange => {
  const [startRange, endRange] = inputRange
  const delta = endRange.diff(startRange, 'hours')
  const [min, max] = boundary

  if (delta > max.diff(min, 'hours')) {
    return boundary
  }
  if (startRange.isBefore(min)) {
    return [min, min.clone().add(delta, 'hours')]
  }
  if (endRange.isAfter(max)) {
    return [max.clone().subtract(delta, 'hours'), max]
  }
  return inputRange
}
